export default __webpack_public_path__ + "static/media/yubor.684843a5.png";